
import 'zoomforth_polyfills/polyfills_basic.js';

import main from 'zoomforth_codesbane_viewer/index.js';
main();
